import { useTranslation } from 'react-i18next';
import { Dropdown } from '../Shared/Dropdown';

const options = [
  {
    text: 'organizations.type.childCareCenter',
    value: 'childCareCenter',
    key: 'childCareCenter',
  },
  {
    text: 'organizations.type.familyChildCare',
    value: 'familyChildCare',
    key: 'familyChildCare',
  },
  {
    text: 'organizations.type.microSchool',
    value: 'microSchool',
    key: 'microSchool',
  },
  {
    text: 'organizations.type.forestSchool',
    value: 'forestSchool',
    key: 'forestSchool',
  },
  {
    text: 'organizations.type.nanny',
    value: 'nanny',
    key: 'nanny',
  },
];

const LocationTypePicker = ({ staticContext, control, children, ...rest }) => {
  const { t } = useTranslation();

  return <Dropdown {...rest} options={options} translator={t} selectOnBlur={false} />;
};

export default LocationTypePicker;
